import { apiFetch, jsonInit } from './api';
import type { WidgetPlacement, WorkspaceTemplate, WorkspaceTemplateLibrary } from '../types';

async function parseTemplateResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    let message = `Template request failed (${response.status})`;
    try {
      const body = await response.json() as { message?: string };
      if (body?.message) message = body.message;
    } catch {
      // Keep the status-based fallback when the server returned no JSON body.
    }
    throw new Error(message);
  }
  return response.json() as Promise<T>;
}

export async function listWorkspaceTemplates(): Promise<WorkspaceTemplateLibrary> {
  const response = await apiFetch('/api/v1/config/workspace-templates');
  return parseTemplateResponse<WorkspaceTemplateLibrary>(response);
}

export async function saveWorkspaceTemplate(input: {
  name: string;
  description?: string;
  grid_gap: number;
  widgets: WidgetPlacement[];
}): Promise<WorkspaceTemplate> {
  const response = await apiFetch('/api/v1/config/workspace-templates', jsonInit('POST', input));
  return parseTemplateResponse<WorkspaceTemplate>(response);
}

export async function deleteWorkspaceTemplate(templateId: string): Promise<void> {
  const response = await apiFetch(`/api/v1/config/workspace-templates/${encodeURIComponent(templateId)}`, {
    method: 'DELETE',
  });
  if (!response.ok) {
    await parseTemplateResponse(response);
  }
}

export async function setDefaultWorkspaceTemplate(templateId: string): Promise<string> {
  const response = await apiFetch(
    '/api/v1/config/workspace-templates/default',
    jsonInit('PUT', { template_id: templateId }),
  );
  const body = await parseTemplateResponse<{ default_template_id: string }>(response);
  return body.default_template_id;
}
